import { render } from "./autocomplete.vue?vue&type=template&id=2a243c2b&scoped=true&ts=true"
import script from "./autocomplete.vue?vue&type=script&lang=ts"
export * from "./autocomplete.vue?vue&type=script&lang=ts"

import "./autocomplete.vue?vue&type=style&index=0&id=2a243c2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a243c2b"]])

export default __exports__